<div class="flex input-s">
  <div>
    <input class="form__input" id="checkbox01" type="checkbox" [checked]="check" />
    <label class="form__label" for="checkbox01">
      <div class="form__icon"></div>
    </label>
  </div>
  <div class="col-12">
    <span>{{label}}</span>
  </div>
</div>
